import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Modal from "@amzn/meridian/esm/components/modal";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import errorIcon from "../../images/error_icon.svg";
import aimsTheme from "../../meridian-theme-aims.json";

/**
 * Modal shown when we see timeouts (504).
 * Offers a Refresh button to reload the app.
 *
 * @param {boolean} isOpen - Controls the modal visibility
 * @returns {JSX.Element}
 */
const AimsTimeoutModal = ({ isOpen }) => {
  return (
    <Theme
      palette={aimsTheme}
      tokens={{
        modalHeaderBackgroundColor: "rgba(124, 209, 187, 0.6)",
        modalHeaderSpacingInsetTop: "0px",
        modalHeaderSpacingInsetBottom: "0px",
        modalHeaderFontSize: "8px",
        modalHeaderMinHeight: "8px",
        modalFooterBorderColor: "#FFFFFF",
      }}
    >
      <Modal
        open={isOpen}
        closeLabel={null}
        shouldCloseOnOverlayClick={true}
        aria-describedby="modal-description"
        fullscreenBreakpoint="0"
        title=" "
        bodySpacingInset="400"
        width="292px"
      >
        <Column spacing="none" spacingInset="none">
          <Column height="16px" />
          <Column spacing="none" spacingInset="none">
            <Row alignmentHorizontal="center" widths="40" spacing="none" spacingInset="none">
              <img src={errorIcon} alt="errorIcon" style={{ display: "block", margin: "auto", width: "40px", height: "auto" }} />
            </Row>
          </Column>
          <Column height="16px" />
          <Row spacing="none" spacingInset="none">
            <Column width="28px"/>
            <Column spacing="none" spacingInset="none">
              <Text fontFamily="amazonEmber" type="h100" alignment="start">
                Getting ready
              </Text>
              <Column height="8px" />
              <Text fontFamily="amazonEmber" type="b200" alignment="start">
                Click "Refresh" in 1 min.
              </Text>
            </Column>
          </Row>
          <Column height="16px" />
          <Column height="32px">
            <Row alignmentHorizontal="center" spacing="none" spacingInset="none">
              <Button type="primary" size="small" minWidth="194px" onClick={() => window.location.reload()}>
                Refresh
              </Button>
            </Row>
          </Column>
          <Column height="32px"/>
        </Column>
      </Modal>
    </Theme>
  );
};

export default AimsTimeoutModal;
